var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 80",
    width: 240,
    height: 80,
    role: "img",
    "aria-label": "Recodeq",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 34,
    r: 19,
    fill: "#1D4ED8",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 24,
    r: 12,
    fill: "#3B82F6",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 7,
    fill: "#93C5FD",
    fillOpacity: 0.85
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 52,
    fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif",
    fontSize: 40,
    fontWeight: 500,
    letterSpacing: -0.4,
    fill: "#0F172A"
  }, "recodeq")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.539f83e2156865d04f156d5b6f364a72.svg";
export { ForwardRef as ReactComponent };